<template>

<div>
    <h1>Приключване на проекта</h1>

    <div class='alert alert-info col-12'>
        Когато завършат всички етапи на проекта, можете да го завършите като оставите описателен текст (ревю) на Видеа, както и да оцените изпълнението на ръководителя на проекта.
    </div> 

    <loading-div v-if='!isReady'></loading-div>

    <div v-if='isReady' class='col-12'>
        <label for='your-review'>
            Вашият рейтинг за цялостното изпълнение на проекта
        </label>
        <div class="d-flex">
            <div class="rate-slider w-100">
                <input type="range"
                       v-model='rating' 
                       class="custom-range pl-0 pr-0" min="1" max="5" step="0.5" 
                       id="client-rate">
                <ol class="rate-scale d-flex justify-content-between">
                    <li><span class="icon icon-thumbs-down"></span></li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li><span class="icon icon-thumbs-up"></span></li>
                </ol>
            </div>

            <div class="rate-result flex-shrink-1 ml-2">{{ rating }}</div>
        </div>

        <label for='your-review'>
            Вашето ревю към Видеа ( Ще се визуалицира в страницата на проекта )
            ( {{ msg.length }} от минимум {{ minLen }} )
        </label>

        <textarea id='your-review' v-model='msg' class='form-control summernote' rows='4'></textarea>

        <button @click='send' class='btn btn-primary mt-3'>
            <span v-if='!hasReview'>Изпрати</span>
            <span v-if='hasReview'>Запази</span>
        </button>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                hasReview : false,
                msg : '',
                rating : 0,
                minLen : 10,
            }
        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('prj:gor', {  p : this.$parent.model.id }, (r) => {

                    if( r.status == 'success' ) {

                        if( r.data.m ) {
                            me.hasReview = true;
                            me.msg = r.data.m;
                            me.rating = r.data.r;
                        }
                        
                        me.isReady = true;
                        me.initSummernote();

                    }

                })
            },


            send() {
                var me = this;

                this.msg = $("#your-review").val();

                if( this.msg.length < this.minLen ) {
                    $.notify("Моля въведете поне " + this.minLen + " символа за ревю","warning");
                    return;
                }

                me.ajax.call('prj:sor', { m : this.msg, p : this.$parent.model.id, r : this.rating }, (r) => {

                    if( r.status == 'success' ) {
                        me.hasReview = true;

                        $.notify('Ревюто ви беше запазено','success');
                    }

                })
            }

        }

    }
</script>
